<div class="p-4">
  <p-toast></p-toast>
  <p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

  <div class="card">
    <p-table
      #dt
      [value]="branches"
      [rows]="10"
      [paginator]="true"
      [totalRecords]="totalRecords"
      [loading]="isLoading"
      [lazy]="true"
      (onLazyLoad)="loadBranches($event)"
      dataKey="id"
      styleClass="p-datatable-striped"
    >
       <ng-template pTemplate="caption">
        <div class="flex w-full items-center">
          <h2 class="m-0">Branches</h2>

          <div class="ml-auto">
            <p-button
              label="New Branch"
              icon="pi pi-plus"
              (onClick)="createBranch()"
            ></p-button>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="name">Branch Name <p-sortIcon field="name"></p-sortIcon></th>
          <th pSortableColumn="code">Branch Code <p-sortIcon field="code"></p-sortIcon></th>
          <th>AR Account</th>
          <th>AP Account</th>
          <th>Reference</th>
          <th style="width:10rem">Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-branch>
        
        <tr>
          <td>{{ branch.name }}</td>
          <td>{{ branch.code ?? null }}</td>
          <td>{{ branch.arAccount ?? null }}</td>
          <td>{{ branch.apAccount ?? null }}</td>
          <td>{{ branch.reference ?? null }}</td>
          <td>
            <div class="flex gap-2">
              <p-button icon="pi pi-pencil" styleClass="p-button-rounded p-button-success" (onClick)="editBranch(branch.id)"></p-button>
              <p-button icon="pi pi-trash" styleClass="p-button-rounded p-button-danger" (onClick)="deleteBranch(branch)"></p-button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="4">No branches found.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>